/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * rox-browser bundles a newer axios that references `process.nextTick` (and `process`)
 * at runtime in the browser. CRA 3 (webpack 4) does not provide a global `process`,
 * so accessing it throws `ReferenceError: process is not defined`.
 *
 * Define a minimal browser-safe shim. Kept intentionally small (only `env` + `nextTick`)
 * so libraries that detect Node via `process.versions.node` still correctly see a browser.
 */
const w = window as any;

if (!w.process) {
  w.process = {};
}

if (!w.process.env) {
  w.process.env = {};
}

if (typeof w.process.nextTick !== 'function') {
  w.process.nextTick = (callback: (...args: any[]) => void, ...args: any[]) => {
    Promise.resolve().then(() => callback(...args));
  };
}

export {};
